export default __webpack_public_path__ + "static/media/PYRA-TokenDistribution.5700018e.png";